import request from '@/common/request'
import { commonParams } from '@/api/config'
import { getToken } from '@/common/auth'

export function QueryContainer(pageIndex, pageSize, sortKey, sortDirect, filters) {
  const loginKey = getToken()
  return request({
    url: './query/QueryContainer',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      pageIndex,
      pageSize,
      sortKey,
      sortDirect,
      filters
    })
  })
}

export function QueryDevice(pageIndex, pageSize, sortKey, sortDirect, filters) {
  const loginKey = getToken()
  return request({
    url: './query/QueryDevice',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      pageIndex,
      pageSize,
      sortKey,
      sortDirect,
      filters
    })
  })
}

export function QueryAlarm(filters) {
  const loginKey = getToken()
  return request({
    url: './query/QueryAlarms',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      filters
    })
  })
}

export function QueryContainerLogs(filters) {
  const loginKey = getToken()
  return request({
    url: './query/QueryContainerLogs',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      filters
    })
  })
}

export function QueryNewContainerLogs(filters, startTime) {
  const loginKey = getToken()
  return request({
    url: './query/QueryNewContainerLogs',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      filters,
      startTime
    })
  })
}

export function QueryNewAlarms(filters, startTime) {
  const loginKey = getToken()
  return request({
    url: './query/QueryNewAlarms',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      filters,
      startTime
    })
  })
}

export function QueryHistory(DeviceID, startTime, endTime) {
  const loginKey = getToken()
  return request({
    url: './query/QueryDeviceHistory',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      DeviceID,
      startTime,
      endTime
    })
  })
}

export function QueryContainerHistory(ContainerID, startTime, endTime) {
  const loginKey = getToken()
  return request({
    url: './query/QueryContainerHistory',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      ContainerID,
      startTime,
      endTime
    })
  })
}




// WEBPACK FOOTER //
// ./src/api/home.js